export const contacts = {
  phone: ["+91 95018 68775","+91 81789 39108"],
  email: [
    "sachin@eazotel.com",
    "sachin@fielmente.com",
    "sumant@eazotel.com",
    "support@eazotel.com",
  ],
  addresses: [
    {
      address_1:
        "Suncity Success Tower, Golf Course Ext Rd, Sector 65, Gurugram, Haryana 122005",
      link: "",
    },
  ],
  socialMedia: {
    facebook: "",
    twitter: "",
    linkedin: "https://www.linkedin.com/company/eazotel/",
    instagram: "https://www.instagram.com/eazotel/",
  },
  logoUrl: "https://dashboard.eazotel.com/login",
};
